import React from 'react';
import { ROUTES } from '../../../../../common/constants';
import GoBackButton from '../../../../../components/GoBackButton';
import Portal from '../../../../../components/Portal';
import InflowTable from '../../../../payments/modules/endUser/components/InflowTable';
import EndUsersTabs from '../components/EndUsersTabs';

const TransactionDetails = ({
  match: { params: { id, userNumber } = {} } = {},
  endUserId,
  endUserNumber,
  isDrawerView = false,
}) => {
  const currentId = isDrawerView ? endUserId : id;
  const currentUserNumber = isDrawerView ? endUserNumber : userNumber;

  const contentComponent = (
    <div className="tab-table">
      <InflowTable userId={currentId} />
    </div>
  );

  if (isDrawerView) {
    return contentComponent;
  }

  return (
    <>
      <Portal portalId="header-title-content">
        <GoBackButton
          customLink={`${ROUTES?.SYSTEM_USERS}${ROUTES?.END_USERS}`}
        />
        <div className="portal-header">Edit End User</div>
      </Portal>
      <EndUsersTabs endUserId={currentId} endUserNumber={currentUserNumber}>
        {contentComponent}
      </EndUsersTabs>
    </>
  );
};

export default TransactionDetails;
